import './education.css';
import React, { useRef } from 'react';
import AnimationforWork from '../animations/AnimationforWork';
import useScrollReveal from '../../hooks/useScrollReveal';

const Education = ({ isDarkMode }) => {
  const containerRef = useRef(null);

  useScrollReveal(containerRef);

  const educationData = [
    {
      logo: '/uncc.png',
      school: 'University of North Carolina at Charlotte',
      degree: 'Master of Science in Mathematical Finance',
      highlight: 'GRE Quant: 170/170',
      location: 'Charlotte, NC',
      dates: 'Graduation May 2026',
      courses: [
        'Financial Elements of Derivatives',
        'Cross Section and Time Series Econometrics',
        'Financial Economic Theory',
      ],
    },
    {
      logo: '/texas.png',
      school: 'Texas Tech University',
      degree: 'Bachelor of Science in Computer Science & Mathematics Minor',
      highlight: 'GPA: 3.7/4.0',
      location: 'Lubbock, TX',
      dates: 'Aug 2020 – Dec 2023',
      courses: [
        'Algorithm Design, Analysis, and Implementation',
        'Computer Architecture',
        'Computer Science Theory',
        'Discrete Computational Structures',
        'Data Structures',
        'Object Oriented Programming',
        'Operating Systems',
        'Programming Languages',
        'Software Engineering',
        'Multiprocessing',
        'Database Systems',
      ],
    },
  ];

  return (
    <>
      <div className="spacery4">
        <div className='headding'>
          <AnimationforWork isDarkMode={isDarkMode} />
          <div className="textDiv">
            <h1> Education </h1>
          </div>
        </div>
      </div>

      <div ref={containerRef} className="container edu-container">
        {educationData.map((edu, index) => (
          <div key={index} className="card edu-card scroll-reveal" data-delay={index + 1}>
            <div className="logo-container">
              <img
                src={isDarkMode ? edu.logo.replace('.png', '-black.png') : edu.logo}
                alt={edu.school}
                className="company-logo"
              />
            </div>

            <div className="info-container">
              <div className="position">
                <strong>{edu.degree}</strong>
              </div>

              <div className="edu-details">
                <span className="degree-title">{edu.school}</span>
                <div className="edu-meta">
                  <span className="edu-highlight">{edu.highlight}</span>
                  <span className="edu-separator">•</span>
                  <span>{edu.location}</span>
                  <span className="edu-separator">•</span>
                  <span>{edu.dates}</span>
                </div>
              </div>

              <div className="courses-grid">
                {edu.courses.map((course, i) => (
                  <span key={i} className="course-pill">
                    {course}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="spacer"></div>
    </>
  );
};

export default Education;
